var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"logo",staticStyle:{"cursor":"pointer"},on:{"click":_vm.reset}},[_c('img',{attrs:{"src":"/assets/images/logo.png"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }